export default __webpack_public_path__ + "static/media/dev-box-preview-win11_light.4bf4203d.jpg";